import React from 'react';
import styled from 'styled-components';
import Humanize from 'humanize-plus';
import SparklineChart from '../charts/SparklineChart';
import { pickLongestSparklineSeries } from '../charts/parseSparklineValues';
import { ChartCell, ChartText } from './sharedStyles';
import { getColumnBorderFlags } from './columnBorderFlags';

const SparklineText = styled(ChartText)`
  pointer-events: none;
`;

const SparklineCell = styled(ChartCell)`
  overflow: visible;
`;

const SparklineCellWrapper = styled.div`
  position: absolute;
  inset: 9px 0 0;
  width: 100%;
  height: calc(100% - 9px);
  overflow: visible;
  font-size: 15px;
  font-weight: 400;
  color: var(--table-cellrenderer-chart-wrapper-text-color);
`;

const SparklineChartWrapper = styled.div`
  position: absolute;
  inset: -14px 0 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  z-index: 1;
`;

export const SparklineRenderer =
  (
    _dataColors: any,
    _tableWidth: any,
    _hasRowNodes: boolean,
    firstColumnIds: Set<string>,
    lastColumnIds: Set<string>,
    columnIds: string[],
    hasScroll: boolean | undefined,
    _indexTitleWidth: number | undefined,
  ) =>
  // eslint-disable-next-line react/display-name
  ({ dataKey, rowData, cellData, columnIndex }: any) => {
    const values = pickLongestSparklineSeries(
      rowData?.[`${dataKey}_Components`],
      rowData?.[`${dataKey}__series`],
      rowData?.[dataKey],
    );
    const seriesData = { data: values };
    const showText = rowData[`${dataKey}ShowText`];
    const { isFirst, isLast } = getColumnBorderFlags(columnIds, columnIndex, firstColumnIds, lastColumnIds, hasScroll);

    return (
      <SparklineCell data-sparkline-cell="true" $isfirst={isFirst ? 1 : 0} $islast={isLast ? 1 : 0}>
        <SparklineCellWrapper>
          {showText && <SparklineText>{Humanize.toFixed(cellData, 2).replace('.00', '')}</SparklineText>}
          <SparklineChartWrapper>
            <SparklineChart data={seriesData} hasTooltip />
          </SparklineChartWrapper>
        </SparklineCellWrapper>
      </SparklineCell>
    );
  };
